const info = {
  subject: 'Paper Wallet History',
  startTime: 1634605200,
  prizeAmount: 50,
  numberOfQuestions: '10',
  timeToAnswer: '10 Seconds'
}
exports.default = info
